import Swal from 'sweetalert2'

// Warehouse modals use z-index 2000. SweetAlert mounts on document.body at
// 1060, so alerts open behind those windows. This mixin lifts only the
// alerts fired from the warehouse screens.
const warehouseSwal = Swal.mixin({
  didOpen: (popup) => {
    const container = popup && popup.parentElement
    if (container) container.style.zIndex = '4000'
  },
})

export default warehouseSwal
